export default "__VITE_ASSET__D$thrwc8__"